import React from 'react';
import { ViewDetail } from 'components/layouts';
import styled from 'styled-components';

const getAboutText = about => {
  if (about) {
    const shortText = about.split('।')[0];
    return shortText + '।';
  }
};

const MunicipalityCard = ({ name, about, type, link }) => {
  return (
    <Content>
      <div className="header">
        <div className="logo">
          <h2 className="logo-title">{name}</h2>
          <span className="logo-text">
            <span>{type}</span>
          </span>
        </div>
      </div>
      <div className="body">
        <p>{getAboutText(about) && getAboutText(about)}</p>

        {link && <ViewDetail pageLink={link} title="थप जानकारी" type="mun" />}
      </div>
    </Content>
  );
};

export default MunicipalityCard;

const Content = styled.div`
  .header {
    background-color: ${props => props.theme.primary.neelo};
    padding: 30px;
    // font-size: 30px;
    // font-weight: 700;
    color: #fff;
    border-radius: 4px 4px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .logo {
      color: #fff;
      line-height: 1;
      display: inline-block;
      text-align: center;
      text-decoration: none;

      .logo-title {
        font-size: 44px;
        font-weight: 700;
        margin: 0 0 6px 0;
      }

      .logo-text {
        color: #fff;
        font-size: 11px;
        position: relative;
        display: block;
        color: rgba(240, 248, 255, 0.56);
        width: 156px;

        &:before,
        &:after {
          content: '';
          position: absolute;
          width: 46px;
          top: 50%;
          height: 2px;
          background-color: rgba(240, 248, 255, 0.56);

          border-radius: 3px;
        }

        &:before {
          left: 0;
        }

        &:after {
          right: 0;
        }
      }
    }
  }

  .body {
    padding: 32px 30px;
    color: #4a4a4a;
    font-size: 18px;
    line-height: 1.44;
    border: 1px solid rgba(151, 151, 151, 0.3);
    border-radius: 0 0 4px 4px;

    > p {
      margin-bottom: 20px;
    }

    a {
      font-size: 14px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/municipalityCard/municipalityCard.js